import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { socket } from 'api';
import { prepareDate } from 'libs/common';
import { Grid, TableHead, TableHeadRow, TableHeaders, GridCell, GridRow } from 'libs/ui';

const timeout = 200;
let timer1;

export const ReceiptTable = (props) => {
  const { name } = props;
  const [items, setItems] = useState(null);
  const [q, setQ] = useState(name);
  // const [count, setCount] = useState(0);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const updateItems = (data) => {
      setItems(data.items);
      // setCount(data.count);
    };

    socket.on('receipt_template.list', updateItems);
    socket.call('receipt_template.list', { filter_params: {}, sort_params: [], paging_params: { limit: 1000, offset: 0 } });

    return () => {
      socket.off('receipt_template.list', updateItems);
    };
  }, [props.update]);

  useEffect(() => {
    if (timer1) {
      clearTimeout(timer1);
    }
    timer1 = setTimeout(() => {
      setQ(name);
    }, timeout);

    return () => {
      if (timer1) {
        clearTimeout(timer1);
      }
    };
  }, [name]);

  // if (!items) {
  //   return <Loader />;
  // }

  // if (!items.length) {
  //   return null;
  // }

  const edit = (el) => {
    props.edit(el);
  };

  const itemsEl =
    items !== null
      ? items
          .filter((el) => (!q ? true : el.name.toLowerCase().includes(q.toLowerCase())))
          .map((el, idx) => {
            const d = prepareDate(el.updated_at, i18n.language);

            return (
              <GridRow key={idx} onClick={() => edit(el)}>
                <GridCell>{el.name}</GridCell>
                <GridCell>{el.width}</GridCell>
                <GridCell style={{ textAlign: 'right' }}>{d}</GridCell>
              </GridRow>
            );
          })
      : [];

  const cl = items === null ? 'loading' : '';

  return (
    <Grid className={cl}>
      <TableHead>
        <TableHeadRow>
          <TableHeaders>{t('tables.Шаблон')}</TableHeaders>
          <TableHeaders width="80">{t('tables.Ширина')}</TableHeaders>
          <TableHeaders width="200" align="right">
            {t('tables.Дата изменения')}
          </TableHeaders>
        </TableHeadRow>
      </TableHead>
      <tbody>{itemsEl}</tbody>
    </Grid>
  );
};
